// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"738":"202dcb21","966":"ff641e4c"}[chunkId] + ".chunk.js";
};